"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextOverflow = exports.SelectGroupContainer = exports.SelectGroupButton = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("./constants");

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PILL_BORDER_RADIUS = 1000;

var getDisplay = function getDisplay(props) {
  return props.isInline ? 'inline-flex' : 'flex';
};

var SelectGroupButton = (0, _designLanguage.withTheming)(_styledComponents["default"].button.withConfig({
  displayName: "styles__SelectGroupButton",
  componentId: "sc-1ggktuh-0"
})(["position:relative;max-width:100%;margin:0;padding:0;display:", ";background-color:", ";min-height:", "px;width:auto;align-items:center;justify-content:center;box-shadow:", ";border-radius:", "px;border:none;color:", ";cursor:", ";transition:background-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;user-select:none;text-decoration:none;text-align:center;&::-moz-focus-inner{outline:none;border-style:none;padding:0;}&:focus{", ";}&:hover{background-color:", ";box-shadow:", ";color:", ";}&:active{background-color:", ";box-shadow:", ";color:", ";}"], getDisplay, function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background'
  })];
}, function (props) {
  return props.theme.Size["Button".concat(_constants.SizeNames[props.size])];
}, function (props) {
  return "inset 0 0 0 ".concat(props.isSelected ? props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOn")] : props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOff")], "px ").concat(props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border'
  })]);
}, function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === _designLanguage.Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground'
  })];
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
}, (0, _designLanguage.getFocusStyles)(), function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Hovered'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Hovered'
  })]);
}, function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Hovered'
  })];
}, function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Pressed'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Pressed'
  })]);
}, function (props) {
  return props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Pressed'
  })];
}));
exports.SelectGroupButton = SelectGroupButton;
var SelectGroupContainer = (0, _designLanguage.withTheming)(_styledComponents["default"].div.withConfig({
  displayName: "styles__SelectGroupContainer",
  componentId: "sc-1ggktuh-1"
})(["border-radius:", "px;", ";& > *{", ";border-radius:", " !important;}& > * + *{margin-left:-1px !important;}", ";"], function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === _designLanguage.Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return !props.isInline ? (0, _styledComponents.css)(["display:flex;width:100%;"]) : (0, _styledComponents.css)(["display:inline-block;max-width:100%;"]);
}, function (props) {
  return !props.isInline ? (0, _styledComponents.css)(["flex:1;"]) : '';
}, _designLanguage.BorderRadius.None, function (props) {
  var borderRadiusValue = props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === _designLanguage.Shape.Pill ? 1000 : props.theme.BorderRadius.ButtonDefault;
  return (0, _styledComponents.css)(["background-color:", ";& > *:first-child{border-radius:", "px 0 0 ", "px !important;}& > *:last-child{border-radius:0 ", "px ", "px 0 !important;}& > *:nth-child(", "){z-index:1 !important;}", ";"], props.theme.Colors[(0, _utils.getColorSemantic)({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background'
  })], borderRadiusValue, borderRadiusValue, borderRadiusValue, borderRadiusValue, props.selectedIndex + 1, props.selectedIndex !== null && (0, _styledComponents.css)(["& > *:nth-child(", "){border-radius:", "px !important;}& > *:nth-child(", "){margin-right:-", "px !important;padding-right:", "px;}& > *:nth-child(", "){margin-left:-", "px !important;padding-left:", "px;}"], props.selectedIndex + 1, borderRadiusValue, props.selectedIndex, props.size, props.size, props.selectedIndex + 2, props.size, props.size));
}));
exports.SelectGroupContainer = SelectGroupContainer;
var TextOverflow = (0, _styledComponents["default"])(_designLanguage.Inset).attrs(function (props) {
  return {
    verticalSize: _designLanguage.Inset.Sizes.None,
    horizontalSize: props.size
  };
}).withConfig({
  displayName: "styles__TextOverflow",
  componentId: "sc-1ggktuh-2"
})(["max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
exports.TextOverflow = TextOverflow;